import InfoPage from '@modules/professional/page/InfoPage';
import { loader } from '@modules/professional/api/info-page-loader.server';
import { shouldRevalidateProfessionalInfoLayout } from '~/modules/professional/util/professional-layout-revalidation';
import type { APHandle } from '~/modules/root';

export const handle: APHandle = {
    showBannerAndLogoMobile: true,
    hideContactArchiPro: true,
};

export { loader };
export const shouldRevalidate = shouldRevalidateProfessionalInfoLayout;
export default InfoPage;
